/* ============================================================
   FF-THEME.JS — Comportamientos globales FlyFarma (vanilla, sin librerías)
   - Reveal on scroll (IntersectionObserver)
   - Botón volver arriba
   - Barra inferior móvil (categorías / buscar / carrito + contador)
   - Toast "añadido al carrito" + sincronización de contadores
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. REVEAL ON SCROLL ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.ff-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ff-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ff-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. BOTÓN VOLVER ARRIBA ---------- */
  function initToTop() {
    var btn = document.querySelector('.ff-to-top');
    if (!btn) return;
    var onScroll = function () {
      if (window.pageYOffset > 420) btn.classList.add('ff-show');
      else btn.classList.remove('ff-show');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    onScroll();
  }

  /* ---------- 3. BARRA INFERIOR MÓVIL ---------- */
  function clickFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }
  function initBottomBar() {
    var bar = document.querySelector('.ff-bottom-bar');
    if (!bar) return;

    var cat = bar.querySelector('[data-ff-action="menu"]');
    if (cat) cat.addEventListener('click', function (e) {
      e.preventDefault();
      // Abre el menú/cajón móvil nativo de Dawn
      clickFirst(['.menu-drawer summary', '.header__icon--menu', 'header-drawer summary', 'details-disclosure summary']);
    });

    var search = bar.querySelector('[data-ff-action="search"]');
    if (search) search.addEventListener('click', function (e) {
      e.preventDefault();
      clickFirst(['details-modal summary.header__icon--search', '.header__icon--search', 'summary.header__icon--search']);
      // Enfoca el campo de búsqueda si aparece
      setTimeout(function () {
        var input = document.querySelector('.search-modal__form input[type="search"], #Search-In-Modal');
        if (input) input.focus();
      }, 120);
    });

    var cart = bar.querySelector('[data-ff-action="cart"]');
    if (cart) cart.addEventListener('click', function (e) {
      e.preventDefault();
      // Abre el cajón del carrito (o navega a /cart como fallback)
      if (!clickFirst(['#cart-icon-bubble'])) {
        window.location.href = cart.getAttribute('href') || '/cart';
      }
    });

    syncCartCount();
  }

  /* ---------- 4. CONTADOR DE CARRITO (sincroniza badge de la barra) ---------- */
  function getCartCount() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) return parseInt(bubble.textContent, 10) || 0;
    return null;
  }
  function syncCartCount(countOverride) {
    var badge = document.querySelector('.ff-bottom-bar__badge');
    if (!badge) return;
    var count = (typeof countOverride === 'number') ? countOverride : getCartCount();
    if (count && count > 0) { badge.textContent = count > 99 ? '99+' : count; badge.style.display = 'flex'; }
    else { badge.style.display = 'none'; }
  }

  /* ---------- 5. TOAST AÑADIDO AL CARRITO ---------- */
  var toastTimer;
  window.ffToast = function (message) {
    var t = document.querySelector('.ff-toast');
    if (!t) return;
    var label = t.querySelector('.ff-toast__text');
    if (label && message) label.textContent = message;
    t.classList.add('ff-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('ff-show'); }, 3200);
  };

  /* Intercepta las llamadas de "añadir al carrito" de Dawn para mostrar el toast
     y refrescar el contador, sin tocar la lógica nativa del carrito. */
  function hookCartAdd() {
    if (!window.fetch || window.__ffFetchHooked) return;
    window.__ffFetchHooked = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = (args[0] && args[0].url) ? args[0].url : args[0];
      var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      return origFetch.apply(this, args).then(function (response) {
        if (isAdd && response && response.ok) {
          try {
            response.clone().json().then(function (data) {
              var name = (data && (data.product_title || data.title)) || '';
              window.ffToast(name ? '“' + name + '” añadido al carrito' : 'Producto añadido al carrito');
            }).catch(function () { window.ffToast('Producto añadido al carrito'); });
          } catch (e) { window.ffToast('Producto añadido al carrito'); }
          // Refresca el contador tras un instante (Dawn actualiza el bubble)
          setTimeout(syncCartCount, 350);
        }
        return response;
      });
    };
  }

  /* Observa cambios en el bubble de carrito de Dawn para mantener el badge al día */
  function observeCartBubble() {
    var holder = document.querySelector('#cart-icon-bubble');
    if (!holder || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { syncCartCount(); });
    mo.observe(holder, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- INIT ---------- */
  function init() {
    initReveal();
    initToTop();
    initBottomBar();
    hookCartAdd();
    observeCartBubble();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Reinit de reveal cuando el editor de Shopify recarga una sección */
  document.addEventListener('shopify:section:load', initReveal);
})();
